export class MealCategoryModel {
    id: number;
    name: string;
    selected: boolean;
    icon: string;

    constructor() {
        this.id = 0;
        this.name = '';
        this.selected = false;
        this.icon = '';
    }

}